import { createSelector } from 'reselect';
import { CONTACT_TYPES, ASSIGNMENT_STATUS } from 'shared/constants';
import sortBy from 'lodash/sortBy';

const getContactTypes = state => state.tcRenewal.contactTypes;
const getTcCycleEvents = state => state.tcRenewal.tcCycleEvents;
const loadingCycleEvents = state => state.tcRenewal.loadingTcCycleEvents;
const getAvailableRenewalDates = state => state.tcRenewal.availableRenewalDates;
const getTcCycle = state => state.tcRenewal.tcCycle;

const defaultEvent = (ev, testCenterCycleId, selected) => ({
  selected,
  optOutFlag: false,
  locationEvents: [],
  testingEvent: ev,
  testCenterCycleId,
  testCenterEventTasks: [],
});

const mapEvents = (availableEvents, testCenterCycleId, cycleEvents) => {
  const mappedEvents = [];
  availableEvents.forEach((ev) => {
    const existentEvent = cycleEvents.find(cycleEv => cycleEv.testingEvent.id === ev.id);
    if (existentEvent) {
      mappedEvents.push({
        selected: existentEvent.testCenterEventStatus === ASSIGNMENT_STATUS.open,
        ...existentEvent,
      });
    } else {
      mappedEvents.push(defaultEvent(ev, testCenterCycleId, false));
    }
  });
  return mappedEvents;
};

const orderEventsByDate = events => sortBy(events, 'testingEvent.testDate');

export const getAlternateContactType = createSelector(
  [getContactTypes],
  (contactTypes) => {
    return contactTypes.find(elem => elem.code === CONTACT_TYPES.alternateContact);
  }
);

export const getMappedContactTypes = createSelector(
  [getContactTypes],
  (contactTypes) => {
    const mappedContactTypes = {};
    contactTypes.forEach((type) => {
      mappedContactTypes[type.code] = type.id;
    });
    return mappedContactTypes;
  }
);

export const getMappedCycleEvents = createSelector(
  [getAvailableRenewalDates, loadingCycleEvents, getTcCycleEvents, getTcCycle],
  (availableDates, loadingEvents, cycleEvents, tcCycle) => {
    const mappedEvents = orderEventsByDate(mapEvents(availableDates, tcCycle.id, cycleEvents));
    return mappedEvents || [];
  }
);

export const filterOpenEvents = createSelector(
  [getTcCycleEvents],
  (cycleEvents) => {
    const filteredEvents =
      orderEventsByDate(cycleEvents.filter(ev => ev.testCenterEventStatus === ASSIGNMENT_STATUS.open));
    return filteredEvents || [];
  }
);
